import { getReplyOutdentClassName } from '../../styles';
export function getReplyClassName(indent, indentModifier, isMobile) {
    if (indentModifier !== undefined) {
        return getReplyOutdentClassName(indent + indentModifier, isMobile);
    }
    if (isMobile) {
        // on mobile reply forms must be outdented
        // all the way to the left
        return getReplyOutdentClassName(indent + 1, isMobile);
    }
    if (indent >= 5) {
        // Reply forms should be at least as wide as level 5
        return getReplyOutdentClassName(indent - 4, isMobile);
    }
    return undefined;
}
//# sourceMappingURL=helpers.js.map